// extracted by mini-css-extract-plugin
export default {"mobileToolBar":"fpaDPx"};